export enum InvoicingOption {
  SEND = 'send', // option send invoice by email
  DO_NOT_SEND = 'do-not-send', // option do not send invoice by email
}
